import React from "react";
import { LanguageMenu } from "./LanguageMenu";
import { LanguageMenuProps } from "./types";
import { Image } from "@/components/ui/image";

export const TopNavigation: React.FC<LanguageMenuProps> = ({
  languages,
  onLanguageChange,
  profileId,
}) => {
  const showPartnerLogo = profileId === "ilsewissink";
  return (
    <>
      {/* Background div for smallest breakpoint */}
      <div className="z-[10] pointer-events-none fixed top-0 left-0 w-full h-[80px] bg-top-navigation-gradient md:hidden"></div>

      <header
        id="TopNavigation"
        role="banner"
        className="z-[10] flex fixed top-0 left-0 w-full max-w-full h-[64px] md:h-header-desktop bg-transparent md:bg-background pointer-events-none
        items-center px-[16px]"
      >
        {/* Left Section: Logos */}
        <div className="flex items-center md:pl-[8px]">
          <div
            className={
              showPartnerLogo
                ? "flex gap-[10px] h-[20px] md:h-[21px]"
                : "flex gap-[10px] h-[24px] md:h-[26px]"
            }
          >
            {showPartnerLogo && (
              <img
                src="/assets/img/propertyLogos/ilsewissink.svg"
                alt="Ilse Wissink Logo"
                className="object-contain max-h-[20px] md:max-h-[21px]"
              />
            )}
            <div
              className={
                showPartnerLogo
                  ? "hidden md:flex items-end gap-[4px] h-full"
                  : "flex items-center h-full"
              }
            >
              {showPartnerLogo && <span className="text-xs">by</span>}
              <img
                src="/assets/img/logoGetLost.svg"
                alt="GetLost"
                className={
                  showPartnerLogo
                    ? "object-contain h-[12px]"
                    : "object-contain h-full max-h-full"
                }
              />
            </div>
          </div>
        </div>

        {/* Right Section: Icons */}
        <div className="flex items-center ml-auto md:pr-[8px]">
          <div className="flex gap-[16px] md:gap-[24px] h-[20px]">
            <LanguageMenu
              languages={languages}
              onLanguageChange={onLanguageChange}
            />
            {/* 
            <div id="Options (button)" className="pointer-events-auto" aria-label="Options menu">
              <img id="Options (button)
                src="/assets/img/button3dots.svg"
                alt="Options"
                className="object-contain w-[18px] md:w-[24px] h-auto"/>
            </div>
            */}
          </div>
        </div>
      </header>
    </>
  );
};
